import React from "react";
import { useState } from "react";
import { useEffect } from "react";
import { useCentralStore } from "../../store/appContext";
import ActionTypes from "../../store/actionTypes";
import Selector from "../../components/common/selector/selector";
import { Button, DatePicker, Table, Upload } from "antd";
import { DownloadOutlined, FileExcelTwoTone, FilePdfTwoTone, UploadOutlined } from "@ant-design/icons";
import { exportJSONToCSV } from "../../utils/upload-utils";
import reconExcelFile from "../../assets/excelFiles/Reconciliation_Sample.xlsx"
import incentiveExcelFile from "../../assets/excelFiles/Sales_Incentives_sample.xlsx"
import { getApplicableSections, getBase64, numberWithCommas } from "../../utils/functionUtils";
import { createStyles } from 'antd-style';
import API from "../../api";
import moment from "moment";
import resources from "../../components/common/resources.json";
import axios from "axios";

const useStyle = createStyles(({ css, token }) => {
  const { antCls } = token;
  return {
    customTable: css`
      ${antCls}-table {
        ${antCls}-table-container {
          ${antCls}-table-body,
          ${antCls}-table-content {
            scrollbar-width: thin;
            scrollbar-color: #eaeaea transparent;
            scrollbar-gutter: stable;
          }
        }
      }
    `,
  };
});

const FinanceReconReport = () => {
  const { styles } = useStyle();
  
  const [months, setMonths] = useState([]);
  const [fileList, setFileList] = useState([]);
  const [uploading, setUploading] = useState(false);
  const [uploadReportData, setUploadReportData] = useState({});

  const [celcomFiananceData, setCelcomFiananceData] = useState();
  const [celcomFiananceColumns, setCelcomFiananceColumns] = useState();
  const [celcomDefaultFiananceDataPeriod, setCelcomDefaultFiananceDataPeriod] = useState();
  const [reportList, setReportList] = useState([]);
  const [dates, setDates] = useState(null);

  const setLoading = (action) => {
    dispatch({ type: ActionTypes.SET_LOADING, payload: action });
  };

  let reconData = [
    {
      item: "Supply Fee",
      totalGrossAds: 345,
      supplyFee: "$ 12",
      subTotal: "$ 4140",
    },
    {
      item: "Incentive",
      totalGrossAds: 333,
      supplyFee: "$ 4",
      subTotal: "$ 1332",
    },
    { item: "", totalGrossAds: "", supplyFee: "Gross Total", subTotal: "$ 5472" },
  ];

  const [{ selectedAccountingMonth, carrierThemeData, userData, userDetails, reportFilterDuration }, dispatch] = useCentralStore();
  const { theme } = carrierThemeData;
  let monthNames = [
    "Jan",
    "Feb",
    "Mar",
    "Apr",
    "May",
    "Jun",
    "Jul",
    "Aug",
    "Sep",
    "Oct",
    "Nov",
    "Dec",
  ];

  useEffect(() => {
    if(getApplicableSections(carrierThemeData?.applicableSections, 'FiananceReconInvoiceReportDownload')) {
    const today = new Date();
    let d;
    let month = [];
    for (let i = 2; i >= 0; i -= 1) {
      d = new Date(today.getFullYear(), today.getMonth() - i, 1);
      month.unshift({
        name: `${monthNames[d.getMonth()]}-${d
          .getFullYear()
          .toString()
          .substr(-2)}`,
        value: `${monthNames[d.getMonth()]}-${d.getFullYear().toString()}`,
      });
      dispatch({
        type: ActionTypes.SELECTED_ACCOUNTING_MONTH,
        payload: selectedAccountingMonth
          ? selectedAccountingMonth
          : month[0]?.value,
      });
      setMonths(month);
    }
    getFiananceReportList()
  }
  }, [getApplicableSections(carrierThemeData?.applicableSections, 'FiananceReconInvoiceReportDownload')]);

  let getFiananceReportList = () => {
    setLoading(true)
    API[ActionTypes.GET_FIANANCE_REPORTS_DETAILS](userData?.access_token, userDetails && userDetails?.email?.split("@")?.[0])
      .then(({ data }) => {
          setLoading(false);
          setReportList(data?.GetAllFinanceReport)
      })
      .catch((err) => {
          setLoading(false);
          dispatch({ type: ActionTypes.SET_API_ERROR, data: true });
          let _payload = {
              level: resources.POST_LOGGER_ERROR,
              category: resources.POST_LOGGER_API,
              ApiName: resources.POST_LOGGER_APINAME,
              message: {
                  error: err,
                  info: {
                      idToken: "",
                  },
              },
          };
          API[ActionTypes.POST_LOGGER](_payload, userData?.access_token, userDetails && userDetails?.email?.split("@")?.[0]);
      });
  }

  const handleChange = (name, value) => {
    setFileList([]);
    dispatch({
      type: ActionTypes.SELECTED_ACCOUNTING_MONTH,
      payload: value,
    });
  };
  let tableColumns = [
    {
      title: "ITEM",
      dataIndex: "item",
      key: "item",
      align: "center",
      width: 200,
    },
    {
      title: "TOTAL CUSTOMER COUNT",
      dataIndex: "totalGrossAds",
      key: "totalGrossAds",
      align: "center",
      width: 250,
    },
    {
      title: "SUPPLY FEE",
      dataIndex: "supplyFee",
      key: "supplyFee",
      align: "center",
      width: 150,
    },
    {
      title: "TOTAL",
      dataIndex: "subTotal",
      key: "subTotal",
      align: "center",
      width: 150,
    },
  ];

  const reportColumn =[
    {
        title: "REPORT",
        dataIndex: "report",
        key: "report",
        align: "center",
        width: 200,
    },
    {
        title: (
            <>
                {/* <span>Path </span>&nbsp; */}
                <DownloadOutlined style={{ fontSize: "20px"}} />
            </>
        ),
        dataIndex: "path",
        key: "path",
        align: "center",
        width: 100,
    },
  ]

  // let reportData = []
  // reportData.push({
  //   report: `${selectedAccountingMonth?.replace("-", " ")} Reconciliation Report`,
  //   path: <Button icon={<FileExcelTwoTone style={{ fontSize: "25px" }} theme="outlined"/> } type="" onClick={(e) => handleDownloadReport(e, "Reconciliation Report")} />
  // })

  const downloadFiananceReport = (e, item) => {
    let payload = {
      ReportType: item?.ReportName?.split(".")[0],
      Range: item?.ReportRange
  }
  setLoading(true);
  API[ActionTypes.SGP_DOWNLOAD_REPORT](payload, userData?.access_token, userDetails && userDetails?.email?.split("@")?.[0])
  .then(({ data }) => {
          setLoading(false);
    if (data) {
      axios({
          url: data?.DownloadReportResponse?.Result, //your url
          method: 'GET',
          responseType: 'blob', // important
      })
      .then((response) => {
          setLoading(false);
          const href = URL.createObjectURL(response.data);
      
          const link = document.createElement('a');
          link.href = href;
          link.setAttribute('download', `${item?.ReportName}_${item?.ReportRange}.xlsx`); //or any other extension
          document.body.appendChild(link);
          link.click();
      
          document.body.removeChild(link);
          URL.revokeObjectURL(href);
      })
      .catch((e)=>{
          setLoading(false);
      })
    }
  })
  .catch((err) => {
      setLoading(false);
      dispatch({ type: ActionTypes.SET_API_ERROR, data: true });
      let _payload = {
          level: resources.POST_LOGGER_ERROR,
          category: resources.POST_LOGGER_API,
          ApiName: resources.POST_LOGGER_APINAME,
          message: {
          error: err,
          info: {
              idToken: "",
          },
          },
      };
      API[ActionTypes.POST_LOGGER](_payload, userData?.access_token, userDetails && userDetails?.email?.split("@")?.[0]);
  });
  }

  let _reportList = reportList?.filter((item) => item?.ReportRange == selectedAccountingMonth)

  const reportDataList = []

  _reportList?.map((item, i) => {
    reportDataList?.push({
      report: `${selectedAccountingMonth?.replace("-", " ")} ${item?.ReportName}`,
        path: <Button icon={
          <FileExcelTwoTone
            style={{ fontSize: "25px" }}
            theme="outlined"/> }
        type=""
        onClick={(e) => downloadFiananceReport(e, item)} />,
    })
  })

  // const reportData = [
  //   {
  //       report: `${selectedAccountingMonth?.replace("-", " ")} Reconciliation Report`,
  //       path: <Button icon={
  //         <FileExcelTwoTone
  //           style={{ fontSize: "25px" }}
  //           theme="outlined"/> }
  //       type=""
  //       onClick={(e) => handleDownloadReport(e, "Reconciliation Report")} />,
  //     },
  //   {
  //       report: `${selectedAccountingMonth?.replace("-", " ")} Incentive Report`,
  //       path: <Button icon={
  //         <FileExcelTwoTone
  //           style={{ fontSize: "25px" }}
  //           theme="outlined"/> }
  //       type=""
  //       onClick={(e) => handleDownloadReport(e, "Incentive Report")} />,
  //     }
      
  // ]

  const getTotalClosingSubs = (data) => {
    return data?.reduce((total, item) => total + item?.TotalCount, 0);
};

  const handleDownloadReport = (e, placeholder) => {
    // exportJSONToCSV(reconReport, selectedAccountingMonth, "starhub");
    const link = document.createElement('a');
    link.href = placeholder === 'Reconciliation Report' ? reconExcelFile : incentiveExcelFile;
    link.setAttribute('download', placeholder === 'Reconciliation Report' ? `ReconReport_${selectedAccountingMonth}` : `IncentiveReport_${selectedAccountingMonth}`);
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  const dynamicStyle = {
    '--th-header': 'white',
    '--font-color': theme?.colors?.primary,
    '--border-color': theme?.colors?.primary
  }
  
  // const props = {
  //   action: '',
  //   onChange: handleUpload,
  //   maxCount: 1
  // };

  const props = {
    onRemove: (file) => {
      const index = fileList.indexOf(file);
      const newFileList = fileList.slice();
      newFileList.splice(index, 1);
      setFileList(newFileList);
    },
    beforeUpload: (file) => {
      setFileList([...fileList, file]);
      return false;
    },
    fileList,
    maxCount: 1
  };

  // useEffect(() => {
  //   console.log('selectedAccountingMonth---', selectedAccountingMonth, '--', uploadReportData);
  // }, [uploadReportData])
  
  const uploadSelectedFile = async () => {
    const base64Obj = await getBase64(fileList[0]);

    let payload = {
      ReportType: fileList?.[0]?.name?.split(".")[0],
      ReportName: fileList?.[0]?.name?.split(".")[0],
      ReportData: base64Obj,
      ReportRange: selectedAccountingMonth
    }

    setLoading(true);
    API[ActionTypes.UPLOAD_FIANANCE_REPORT](payload, userData?.access_token, userDetails && userDetails?.email?.split("@")?.[0])
      .then(({ data }) => {
          setLoading(false);
          setFileList([])
          getFiananceReportList()
      })
      .catch((err) => {
          setLoading(false);
          setFileList([])
          dispatch({ type: ActionTypes.SET_API_ERROR, data: true });
          let _payload = {
              level: resources.POST_LOGGER_ERROR,
              category: resources.POST_LOGGER_API,
              ApiName: resources.POST_LOGGER_APINAME,
              message: {
                  error: err,
                  info: {
                      idToken: "",
                  },
              },
          };
          API[ActionTypes.POST_LOGGER](_payload, userData?.access_token, userDetails && userDetails?.email?.split("@")?.[0]);
      });
  };


useEffect(() => {
  if(getApplicableSections(carrierThemeData?.applicableSections, 'FiananceProductIDClosingSubsTable') || reportFilterDuration){
    var y, m;
    var firstDaypreviousmonth;
    var lastDaypreviousmonth;
        
    const lastmonth = moment().month();
    const currentyear = moment().year()
    y = currentyear
    m = lastmonth
    firstDaypreviousmonth = moment(new Date(Number(y), Number(m-1), 1)).format('YYYY-MM-DD 00:00:00');
    lastDaypreviousmonth = moment(new Date(Number(y), Number(m), 0)).format('YYYY-MM-DD 23:59:59');
    
    const date = new Date()
    
    const currentDate = new Date(date);
  
    // Get current month and year
    const currentMonth = currentDate.getMonth(); // Month (0-11)
    const currentYear = currentDate.getFullYear(); // Year
  
    // Calculate the previous month
    let prevMonthIndex = currentMonth - 1;
    let prevYear = currentYear;
  
    // Adjust if the previous month is before January
    if (prevMonthIndex < 0) {
        prevMonthIndex = 12; // December
        prevYear--; // Decrement year
    }

    setCelcomDefaultFiananceDataPeriod(prevYear + '-' + prevMonthIndex);
    let payload = {
      ReportMonth: reportFilterDuration?.duration?.replace('-', ''),
      // StartDate: reportFilterDuration?.startDate || firstDaypreviousmonth,
      // EndDate: reportFilterDuration?.endDate || lastDaypreviousmonth
    };

    setLoading(true);  
    API[ActionTypes.GET_CELCOM_FIANANCE_DETAILS](payload, userData?.access_token, userDetails && userDetails?.email?.split("@")?.[0])
      .then(({ data }) => {
        setLoading(false);
        if (data) {
          setCelcomFiananceData(data?.GetVolumeClosingResponse)
          let tableCelcomFiananceColumns = [];
          const totalKeys = {};

          data?.GetVolumeClosingResponse?.reduce((acc, current) => {
            const keys = Object.keys(current);
            for (var i in keys) {
              totalKeys[keys[i]] = 1;
            }
          }, totalKeys);

          var keys = Object.keys(totalKeys);
          for (var i in keys) {
            tableCelcomFiananceColumns?.push({
              title: keys[i]?.replace('ClientProductSkuNBR', "Product ID")?.replace('TotalCount', "Closing Subs"),
              dataIndex: keys[i],
              key: keys[i],
              width: 280,
              align: "center",
            });
          }
          setCelcomFiananceColumns(tableCelcomFiananceColumns);
        }
      })
      .catch((err) => {
        setLoading(false);
        setCelcomFiananceData([])
        dispatch({ type: ActionTypes.SET_API_ERROR, data: true });
        let _payload = {
          level: resources.POST_LOGGER_ERROR,
          category: resources.POST_LOGGER_API,
          ApiName: resources.POST_LOGGER_APINAME,
          message: {
            error: err,
            info: {
              idToken: "",
            },
          },
        };
        API[ActionTypes.POST_LOGGER](_payload, userData?.access_token, userDetails && userDetails?.email?.split("@")?.[0]);
      }
    )
  }
}, [getApplicableSections(carrierThemeData?.applicableSections, 'FiananceProductIDClosingSubsTable'), reportFilterDuration])

const reportCelcomFiananceData = function (_celcomFiananceData) {
      return _celcomFiananceData?.map((obj) => {
        let dateObj = {}
        Object.entries(obj).map(([key, value]) => {          
          (dateObj[key] = key?.toUpperCase()?.includes("TOTALCOUNT")
              ? value?.length !== 0
                ? numberWithCommas(value) //moment(value).format("DD-MM-YYYY HH:mm:ss")
                : 0
              : value)
        })
        return dateObj
      })
  };

  const currentMonth = moment().month();
      const currentYear = moment().year();
      const disabledMonth = (current) => {
          const month = current.month();
          const year = current.year();
          return year < 2024 || (year === 2024 && month < 4) || year > currentYear || (year === currentYear && month > currentMonth);
      };

      const handleDateChange = (dates, dateString, type) => {
        setDates(dates);
        setFileList([]);
        dispatch({
          type: ActionTypes.SELECTED_ACCOUNTING_MONTH,
          payload: dates?.format('MMM-YYYY'),
        });
        
    };


  return (
    <>
    {/* w-4/5  */}
      {getApplicableSections(carrierThemeData?.applicableSections, 'FiananceReconInvoiceReportDownload') &&
      <div className="flex justify-end items-start h-full mx-5 absolute top-[17%] right-[6%]">
        {/* <div className="flex items-center justify-end text-black">
          <Selector
            key="Channel Dropdown"
            options={months}
            label="Month"
            value={selectedAccountingMonth}
            onSelect={(name, val) => handleChange(name, val)}
            placeholder="Select month"
            isStarhub={true}
            theme={theme}
          />
        </div> */}
          <div className="flex items-center justify-end text-black mr-2">'
            <DatePicker
                allowClear={false}
                className={``}
                picker="month"
                onChange={(d, ds, t) => (handleDateChange(d, ds, 'month'))}
                value={dates}
                disabledDate={disabledMonth}
            />
          </div>
          <div className="flex flex-col">
            <Upload {...props}>
              {fileList?.length === 0 && <Button icon={<UploadOutlined className="uploadIcon" />} className="borderStyle" style={dynamicStyle}>Upload Report</Button>}
              </Upload>
              {fileList?.length !== 0 && 
              <Button
              type="link"
              onClick={uploadSelectedFile}
              className="textFontStyle underline"
              style={dynamicStyle}
              disabled={fileList?.length === 0}
              loading={uploading}
              // style={{
              //   marginTop: 16,
              // }}
            >
              {uploading ? 'Uploading' : 'Click to Upload'}
            </Button>
            }
            {/* <Upload {...props}>
              <Button icon={<UploadOutlined />} className="borderStyle" style={dynamicStyle}>Upload Report</Button>
            </Upload>
            {fileList?.length !== 0 && 
            <Button
              type="link"
              disabled={fileList.length === 0}
              loading={uploading}
              onClick={uploadSelectedFile}
              className="textFontStyle"
              style={dynamicStyle}
            >
              {uploading ? 'Uploading' : 'Start Upload'}
            </Button>} */}
          </div>
      </div>
      }

      {/* <div className="w-1/2 pb-2 mx-auto mt-2">
        <p className="flex flex-row items-center justify-center mt-5 mb-4 font-bold text-black">
          Finance Reconciliation & Invoice -{" "}
          {selectedAccountingMonth?.replace("-", " ")}
        </p>
        <Table
          columns={tableColumns}
          dataSource={reconData}
          rowKey="data"
          key="data"
          pagination={false}
          className="border-current border-white table-css hz-scrollbar"
          style={dynamicStyle}
        />
      </div> */}
      {getApplicableSections(carrierThemeData?.applicableSections, 'FiananceReconInvoiceReportDownload') &&
        <div className="w-full mx-auto mt-10">
          <Table
            columns={reportColumn}
            dataSource={reportDataList}
            rowKey="data"
            key="data"
            pagination={false}
            className="pb-4 border-current border-white table-css hz-scrollbar"
            style={dynamicStyle}
          />
        </div>
      }
      {celcomFiananceData && getApplicableSections(carrierThemeData?.applicableSections, 'FiananceProductIDClosingSubsTable') &&
        <div className="w-full mx-auto">
          {/* <span className="text-black text-[10px] underline float-right mb-2">Showing data for Month - {reportFilterDuration?.duration || celcomDefaultFiananceDataPeriod}</span> */}
          <Table
            columns={celcomFiananceColumns}
            dataSource={reportCelcomFiananceData(celcomFiananceData) || celcomFiananceData}
            rowKey="data"
            key="data"
            pagination={false}
            className={`${styles?.customTable} pb-4 border-current border-white fiance-productClosingSubstable-css hz-scrollbar`}
            style={dynamicStyle}
            scroll={{
              y: 72 * 5,
            }}
            summary={() => (
              <Table.Summary fixed>
                <Table.Summary.Row>
                  <Table.Summary.Cell index={0}>Total</Table.Summary.Cell>
                  <Table.Summary.Cell index={0}>{numberWithCommas(Math.round(Number(getTotalClosingSubs(celcomFiananceData)))) || '-'}</Table.Summary.Cell>
                </Table.Summary.Row>
              </Table.Summary>
            )}
            // footer={() => <Table
            //   columns={productIDClosingSubsFooterColumn}
            //   dataSource={[]}
            //   rowKey="data"
            //   key="data"
            //   pagination={false}
            //   className="border-current border-white hz-scrollbar"
            //   style={dynamicStyle}
            // />}
          />
        </div>
      }
    </>
  );
};

export default FinanceReconReport;
